import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import { escapeHtml, rescueHtml, capitalizeFirstLetter } from '../../Components/Tools';
import Dialog from "../../Components/Dialog";
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import { useForm } from "react-hook-form";
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';
import { ReactComponent as Trash } from '../../Img/icon-trash.svg';
import { ReactComponent as Add } from '../../Img/icon-add.svg';

const ResponsablesSaisieTbm = (props) =>
{
    const [respSaisie, setRespSaisie] = useState([]);
    const [userSelected, setUserSelected] = useState(null);
    
    const purple = '#6571FE';
    const green = '#59B44A';
    
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    async function callbackDialog(ret) {
        if (ret === true) {
            await suppress(props.user.id_budget, userSelected);
        }
        await setUserSelected(null);
    }

    useEffect(() => {
        if (!props.user) {
            props.getUser()
        }
        else {
            if (props.user.id_budget) {
                const url = 'https://app-slfinance.fr/api/responsable_saisie.php';
                const params = {
                    'getRespSaisie': true,
                    'id_budget': props.user.id_budget
                }
                axios.post(url, qs.stringify(params))
                .then((res) => {
                    var tmp = []
                    res.data.forEach((responsable, i) => {
                        tmp[i] = [responsable.email, responsable.nom, responsable.prenom];
                    });
                    setRespSaisie(tmp);
                })
            }
        }
    }, [props.user])


    function suppress(id, email) {
        const url = 'https://app-slfinance.fr/api/responsable_saisie.php';
        const params = {
            'suppressRespSaisie': true,
            'id_budget': id,
            'email': email
        }
        axios.post(url, qs.stringify(params))
        .then((res) => {
            if (res.data['status'] === 1) {
                NotificationManager.success(res.data['status_message'], '', 700);
                setTimeout(() => window.location = window.location.href, 900);
            }
            else {
                NotificationManager.warning(res.data['status_message'], '', 2000);
            }
        })
        .catch((err) => {
            console.warn(err)
        })
    }

    // Resultat du formulaire
    const { register, handleSubmit } = useForm();
    const onSubmit = async (data) => {

        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (data.nom != '' && data.prenom != '' && data.mail != '') {
            if (data.mail.match(validRegex)) {
                // Si tous les champs sont remplis et que le format du mail est ok allors on ls ajoute en BDD

                const url = 'https://app-slfinance.fr/api/responsable_saisie.php';
                const params = {
                    'addRespSaisie': true,
                    'id_budget': props.user.id_budget,
                    'email': escapeHtml(data.mail),
                    'nom': escapeHtml(capitalizeFirstLetter(data.nom)),
                    'prenom': escapeHtml(capitalizeFirstLetter(data.prenom))
                }
                axios.post(url, qs.stringify(params))
                .then((res) => {
                    if (res.data['status'] === 1) {
                        NotificationManager.success(res.data['status_message'], '', 700);
                        setTimeout(() => window.location = window.location.href, 900);
                    }
                    else {
                        NotificationManager.warning(res.data['status_message'], '', 2000);
                    }
                })
                .catch((err) => {
                    console.warn(err)
                })
            }
            else {
                NotificationManager.warning("Format de l'adresse email invalide", '', 2000);
            }

        }
        else {
            NotificationManager.warning("Veuillez renseigner tous les champs", '', 2000);
        }
    };

	return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex', margin: 25}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Responsables de saisie du tableau de bord mensuel</p>
                </div>

                <div className='shadow-md' style={{flex: 1, textAlign: 'center',  borderRadius: 8, padding: 18, margin: 1, backgroundColor: 'white', boxShadow: '0 6px 18px rgba(0,0,0,0.06)'}}>

                    <Dialog
                        setModalVisible={setDialogModalVisible}
                        modalVisible={dialogModalVisible}
                        callbackDialog={callbackDialog}
                        message={"Confirmez la suppression"}
                    />

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div style={{display: 'flex', flexDirection: 'column', gap: 8, textAlign: 'left'}}>
                            <div style={{marginBottom: 20}}>
                                <p style={{textAlign: 'center', fontWeight: '600'}}>Indiquez les personnes qui recevront un e-mail chaque mois pour compléter le tableau de bord.</p>
                            </div>

                            {(props.user?.id_type_users == '1' || props.user?.id_type_users == '2') &&
                            <div style={{display: 'flex', gap: 12, alignItems: 'flex-end', marginTop: 8}}>
                                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                                    <label style={{fontSize: 12, color: '#444', marginBottom: 6}}>Nom</label>
                                    <input
                                    style={{width: '100%', border: '1px solid #E9ECEF', borderRadius: 6, padding: '10px 12px'}}
                                    placeholder='Nom'
                                    {...register("nom")}
                                    />
                                </div>

                                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                                    <label style={{fontSize: 12, color: '#444', marginBottom: 6}}>Prénom</label>
                                    <input
                                    style={{width: '100%', border: '1px solid #E9ECEF', borderRadius: 6, padding: '10px 12px'}}
                                    placeholder='Prénom'
                                    {...register("prenom")}
                                    />
                                </div>

                                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                                    <label style={{fontSize: 12, color: '#444', marginBottom: 6}}>Email</label>
                                    <input
                                    style={{width: '100%', border: '1px solid #E9ECEF', borderRadius: 6, padding: '10px 12px'}}
                                    placeholder='email@exemple.com'
                                    {...register("mail")}
                                    />
                                </div>

                                <div style={{display: 'flex', alignItems: 'center'}}>
                                    <button type="submit" style={{display: 'flex', alignItems: 'center', gap: 8, backgroundColor: green, color: 'white', border: 'none', padding: '10px 14px', borderRadius: 6, cursor: 'pointer'}}>
                                        <Add width="14" />
                                        <span>Ajouter</span>
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </form>

                    <div style={{marginTop: 30}}>
                        {respSaisie.length !== 0 ?
                        <div style={{display: 'grid', gap: 10}}>
                            {respSaisie.map((responsable, i) => {
                                const email = rescueHtml(responsable[0]);
                                const nom = rescueHtml(responsable[1] || '');
                                const prenom = rescueHtml(responsable[2] || '');
                                const displayName = (prenom || nom) ? `${prenom} ${nom}`.trim() : email;
                                const initials = ((prenom||'')[0] || (nom||'')[0] || email[0] || '').toUpperCase();
                                return (
                                <div key={i} style={{display: 'flex', }}>
                                    <div style={{flex: 1}}></div>
                                    <div className='shadow-md'
                                    style={{display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'space-between', padding: 12, border: '1px solid #F0F2F5', borderRadius: 8}}>
                                        <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                                            <div style={{width: 42, height: 42, borderRadius: 21, backgroundColor: '#F2F4FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, color: '#3A3EDE'}}>{initials}</div>
                                            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'left'}}>
                                                <div style={{fontWeight: 600}}>{displayName}</div>
                                                <div style={{fontSize: 13, color: '#666'}}>{email}</div>
                                            </div>
                                        </div>
                                        <div>
                                            <button
                                            title="Supprimer"
                                            onClick={async () => {
                                                await setDialogModalVisible(true);
                                                await setUserSelected(email);
                                            }}
                                            style={{background: 'transparent', border: 'none', cursor: 'pointer'}}>
                                                <Trash width="18" />
                                            </button>
                                        </div>
                                    </div>
                                    <div style={{flex: 1}}></div>
                                </div>
                                )
                            })}
                        </div>:
                        <div style={{padding: 20, color: '#999', textAlign: 'center'}}>
                            <p style={{margin: 0}}>Aucune personne n'est enregistrée</p>
                        </div>}
                    </div>
                </div>
            </Access>
        </div>
	);
}

export default ResponsablesSaisieTbm;
